/**
 * 全局错误码 i18n 资源
 * 提供统一的错误码消息定义，供各个项目使用
 */

import errorCodeCn from './locales/cn.json';
import errorCodeEn from './locales/en.json';
import errorCodeJp from './locales/jp.json';
import errorCodeTw from './locales/tw.json';

/**
 * 错误码国际化消息对象
 */
export const errorCodeMessages = {
    cn: errorCodeCn,
    en: errorCodeEn,
    jp: errorCodeJp,
    tw: errorCodeTw,
};

/**
 * 支持的语言类型
 */
export type SupportedLocale = 'cn' | 'en' | 'jp' | 'tw';

/**
 * 获取指定语言的错误码消息
 * @param locale 语言代码
 * @returns 错误码消息对象
 */
export function getErrorCodeMessages(locale: SupportedLocale) {
    return errorCodeMessages[locale] || errorCodeMessages.en;
}

/**
 * 导出各语言的错误码消息（便于按需导入）
 */
export {
    errorCodeCn,
    errorCodeEn,
    errorCodeJp,
    errorCodeTw,
};
